import React from 'react';
import './Join.css';

const roles = [
  { title: 'Prompt Engineer', tag: 'AI', desc: 'Проектируешь поведение агентов и разбираешься, как вытащить максимум из языковых моделей.' },
  { title: 'ML Developer', tag: 'AI', desc: 'Знаешь, как работает машинное обучение изнутри и хочешь применять это в реальном продукте.' },
  { title: 'Python Developer', tag: 'Backend', desc: 'Junior+ или middle. Пишешь чистый код и не боишься работать рядом с AI-системами.' },
  { title: 'Golang Developer', tag: 'Backend', desc: 'Любишь скорость и надёжность. Опыт с Go и желание разбираться в новом стеке.' },
];

export default function Join() {
  return (
    <section className="section" id="join" style={{ background: 'var(--bg-surface)' }}>
      <div className="container">
        <div className="join__header reveal">
          <div className="section-label">// 004 · вакансии</div>
          <h2 className="section-title">
            Кого ищем
          </h2>
          <p className="join__sub">
            Нам важны не только навыки — нам важно, хочешь ли ты
            <em> по-настоящему</em> работать над AI-продуктом.
          </p>
        </div>

        <div className="join__roles">
          {roles.map((r) => (
            <div key={r.title} className="join__role reveal">
              <div className="join__role-top">
                <span className="join__role-title">{r.title}</span>
                <span className={`join__role-tag join__role-tag--${r.tag.toLowerCase()}`}>{r.tag}</span>
              </div>
              <p className="join__role-desc">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="join__cta reveal">
          <div className="join__cta-inner">
            <div className="join__cta-glow" />
            <h3 className="join__cta-title">
              Звучит как твоё?
            </h3>
            <p className="join__cta-desc">
              Напиши нам — расскажи немного о себе, о том,
              что ты делал и почему тебе интересен наш проект.
              Форматы CV не обязательны.
            </p>
            <a
              href="mailto:urajitech@gmail.com"
              className="join__cta-btn"
            >
              Написать нам →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
